import { useContext } from 'react';

import {
    START_LOADER,
    STOP_LOADER,
} from '../constants';
import { LoaderContext } from '../context/LoaderContext';
import { generateRandomString } from '../utils/stringHelper';

const createLoader = (dispatch) => (key = generateRandomString(5)) => {
    const start = () => dispatch({ type: START_LOADER, payload: key });
    const stop = () => dispatch({ type: STOP_LOADER, payload: key });

    return { start, stop };
};

export const useLoader = () => {
    const { dispatch } = useContext(LoaderContext);

    return createLoader(dispatch);
};
